import React from 'react';

const AccountSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.49902 19.6025C5.49902 18.2672 5.49902 17.5995 5.65687 17.0544C6.03846 15.7367 7.0687 14.7064 8.38642 14.3248C8.93152 14.167 9.59921 14.167 10.9346 14.167H13.0661C14.4015 14.167 15.0692 14.167 15.6143 14.3248C16.932 14.7064 17.9623 15.7367 18.3438 17.0544C18.5017 17.5995 18.5017 18.2672 18.5017 19.6025" stroke="white" stroke-opacity="0.6" stroke-width="1.3"/>
    <path d="M11.9998 10.9165C10.201 10.9165 8.74902 9.46451 8.74902 7.66577C8.74902 5.86703 10.201 4.41504 11.9998 4.41504C13.7985 4.41504 15.2505 5.86703 15.2505 7.66577C15.2505 9.46451 13.7985 10.9165 11.9998 10.9165Z" stroke="white" stroke-opacity="0.6" stroke-width="1.3"/>
  </svg>
);

export default AccountSvg;